import styled from '@emotion/styled';
import { Button, Ui } from '@silvertours/front-shared';
import Checked from '@engineering/icons/checked';

const StyledForm = styled.form`
  display: flex;
  flex-direction: column;
`;

const ImageWrapper = styled.div`
  margin: ${({ theme }) => theme.spacing[20]} 0
    ${({ theme }) => theme.spacing[40]};
  text-align: center;
`;

const Subheadline = styled.p`
  margin: ${({ theme }) => theme.spacing[40]} 0
    ${({ theme }) => theme.spacing[50]};
  font-family: ${({ theme }) => theme.fontFamily.alternate};
  font-weight: normal;
  font-size: 1.5rem;
  line-height: 1.5;
  color: ${({ theme }) => theme.colors.neutral.grey160};
  text-align: center;
`;

const FormActionArea = styled.div`
  display: flex;
  justify-content: center;
`;

const MaxWidthWrapper = styled.div`
  max-width: 455px;
  width: 100%;
`;

const InputWrapper = styled.div`
  margin-bottom: 1rem;
`;

const PasswordLostWrapper = styled.p`
  margin: ${({ theme }) => theme.spacing[50]}
    ${({ theme }) => theme.spacing[40]};
  font-size: 1rem;
  font-family: ${({ theme }) => theme.fontFamily.alternate};
  text-align: center;
`;

const SignupWrapper = styled.section`
  margin-top: ${({ theme }) => theme.spacing[50]};
  text-align: center;
`;

const SignupHeadline = styled.p`
  margin: ${({ theme }) => theme.spacing[40]} 0;
  font-family: ${({ theme }) => theme.fontFamily.alternate};
  font-weight: normal;
  font-size: 1.25rem;
  line-height: 1.5;
  color: ${({ theme }) => theme.colors.neutral.grey160};
  text-align: center;
`;

const buttonLabelOverride = `
  p,
  span {
    font-size: 1rem;
    font-weight: normal;
  }
`;

const SubmitButton = styled(Button)`
  height: 3.5rem;
  padding: 0 1rem;
  ${buttonLabelOverride}
`;

const SignupButton = styled(Button)`
  height: 3.5rem;
  padding: 0 0.875rem;
  ${buttonLabelOverride}
`;

/*
 * The way back to the provider step, shown only while social login is on.
 * The negative horizontal margin cancels the padding the overlay (or the
 * mobile menu wrapper) puts around this content, so the grey background
 * bleeds edge to edge instead of leaving a white margin on either side.
 */
const BackToOptions = styled.div`
  margin: ${({ theme }) => `${theme.spacing[50]} -${theme.spacing[40]} -${theme.spacing[50]}`};
  padding: 1rem ${({ theme }) => theme.spacing[40]};
  text-align: center;
  background-color: ${({ theme }) => theme.colors.neutral.grey20};

  ${({ theme }) => theme.mq('lg')} {
    margin-inline: -${({ theme }) => theme.spacing[60]};
    margin-bottom: -${({ theme }) => theme.spacing[60]};
    padding-inline: ${({ theme }) => theme.spacing[60]};
  }
`;

const BackToOptionsLink = styled(Ui.TextLink)`
  &:hover {
    text-decoration: none;
  }
`;

const CheckIcon = styled(Checked)`
  margin-left: 0.5em;
  width: 1rem;
  height: 1rem;
  fill: ${({ theme }) => theme.colors.brand.green120};
  vertical-align: middle;
`;

const ErrorMessage = styled(Ui.Message)`
  margin-top: 0;
`;

export {
  BackToOptions,
  BackToOptionsLink,
  CheckIcon,
  ErrorMessage,
  FormActionArea,
  ImageWrapper,
  InputWrapper,
  MaxWidthWrapper,
  PasswordLostWrapper,
  SignupButton,
  SignupHeadline,
  SignupWrapper,
  StyledForm,
  Subheadline,
  SubmitButton,
};
